import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { SelectField } from 'components';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import { ExportSitesByType } from '../../../actions/SiteTrackerActions';

const SiteTrackerOptionsDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const phases = [ { text: 'NNS', value: 'NNS' },
		 { text: 'Rollout PH1', value: 'Rollout PH1' },
		 { text: 'Rollout PH2', value: 'Rollout PH2' },
		 { text: 'Rollout PH3', value: 'Rollout PH3' },
		 { text: 'All', value: 'All' } ];

	const [phase, setPhase] = useState(''); 
	
	const handlePhaseChange = (e) => { setPhase(e.target.value); };

	const _onConfirmClick = () => {
		dispatch(ExportSitesByType(userId, role, phase));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Options"
			confirmLabel="Export"
			onConfirmClicked={_onConfirmClick}
			cancelLabel="Close"
		>
			<div
				style={{ marginTop: '10px' }}
			>
				<SelectField
					id="phase"
					name="phase"
					hintText="Phase"
					defaultValue=""
					menuItems={phases}
					value={phase || ''}
					onChange={handlePhaseChange}
				/>
			</div>
		</ModalDialog>
	);
};

SiteTrackerOptionsDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default SiteTrackerOptionsDialog;
